import arrow from 'assets/svg/arrow.svg';
import calendar from 'assets/svg/calendar.svg';
import cancel from 'assets/svg/cancel.svg';
import caution from 'assets/svg/caution.svg';
import download from 'assets/svg/download.svg';
import eyeOff from 'assets/svg/eyeOff.svg';
import eyeOn from 'assets/svg/eyeOn.svg';
import file from 'assets/svg/file.svg';
import flag from 'assets/svg/flag.svg';
import folder from 'assets/svg/folder.svg';
import lock from 'assets/svg/lock.svg';
import man from 'assets/svg/man.svg';
import passport from 'assets/svg/passport.svg';
import search from 'assets/svg/search.svg';
import selfie from 'assets/svg/selfie.svg';
import hamburger from 'assets/svg/hamburger.svg';
import leftleft from 'assets/svg/leftleft.svg';
import left from 'assets/svg/left.svg';
import right from 'assets/svg/right.svg';
import rightright from 'assets/svg/rightright.svg';
import alphabetT from 'assets/svg/alphabetT.svg';
import yucho from 'assets/svg/yucho.svg';
import auroraBox from 'assets/svg/auroraBox.svg';

export const icons = {
  arrow,
  calendar,
  cancel,
  caution,
  download,
  eyeOff,
  eyeOn,
  file,
  flag,
  folder,
  lock,
  man,
  passport,
  search,
  selfie,
  hamburger,
  left,
  leftleft,
  right,
  rightright,
  alphabetT,
  yucho,
  auroraBox,
};
